import styles from './selection-actions.module.css';
import { Flex, IconButton, Tooltip, Popconfirm, Icon, iconWeight, space } from '@nula/core-ui';

export interface SelectionAction {
  key: string;
  icon: string;
  label: string;
  onClick: () => void;
  danger?: boolean;
  /** If set, wraps the button in a Popconfirm with this message before firing onClick. */
  confirm?: string;
  /** Slot for a wrapper node rendered around the button (e.g. a picker popover). */
  wrapper?: (btn: React.ReactNode) => React.ReactNode;
}

interface SelectionActionsProps {
  actions: SelectionAction[];
}

export function SelectionActions({ actions }: SelectionActionsProps) {
  return (
    <Flex align="center" gap={space[2]}>
      {actions.map((action) => {
        const btn = (
          <Tooltip key={action.key} title={action.label} placement="top">
            <IconButton
              size="sm"
              aria-label={action.label}
              className={action.danger ? styles.danger : styles.default}
              onClick={action.confirm ? undefined : action.onClick}
            >
              <Icon name={action.icon} size={16} weight={iconWeight.light} />
            </IconButton>
          </Tooltip>
        );

        const wrapped = action.confirm ? (
          <Popconfirm
            key={action.key}
            title={action.confirm}
            okText={action.label}
            okDanger={action.danger}
            placement="top"
            onConfirm={action.onClick}
          >
            {btn}
          </Popconfirm>
        ) : btn;

        return action.wrapper ? (
          <div key={action.key} className={styles.slot}>
            {action.wrapper(wrapped)}
          </div>
        ) : wrapped;
      })}
    </Flex>
  );
}
